import Vue from "vue";
import Router from "vue-router";
import Home from "./views/Home.vue";

Vue.use(Router);

const router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/",
      name: "home",
      component: Home,
      meta: {
        title: "Newfound Pioneer Corps Arma 3",
        tags: [
          {
            name: "description",
            content:
              "The Newfound Pioneer Corps is an Arma 3 unit focussing on playing lots of different settings " +
              "in regular events. Become an NPC today!",
          },
        ],
      },
    },
    {
      path: "/events",
      name: "events",
      // route level code-splitting
      // this generates a separate chunk (events.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () =>
        import(/* webpackChunkName: "events" */ "./views/Events.vue"),
      meta: {
        title: "Events – Newfound Pioneer Corps Arma 3",
        tags: [
          {
            name: "description",
            content:
              "Sign up for one of our events by checking out our event calendar. All dates are shown in " +
              "your local timezone and can be joined by the click of a button.",
          },
        ],
      },
    },
    {
      path: "/events/create",
      name: "createEvent",
      component: () =>
        import(/* webpackChunkName: "events" */ "./views/EventEditor.vue"),
      meta: {
        title: "Create & Host – Newfound Pioneer Corps Arma 3",
        tags: [
          {
            name: "description",
            content:
              "Host your own Arma 3 event for the Newfound Pioneer Corps! Set a name, put a small " +
              "description, pick a mod pack and you are good to go.",
          },
        ],
      },
    },
    {
      path: "/events/success",
      name: "created",
      component: () =>
        import(/* webpackChunkName: "events" */ "./views/EventCreated.vue"),
    },
    {
      path: "/events/:name",
      name: "event",
      component: () =>
        import(/* webpackChunkName: "events" */ "./views/Event.vue"),
      meta: {
        tags: [
          {
            name: "description",
            content:
              "All information about the Arma 3 event is gathered on this page. Join by signing up with your " +
              "Discord user on the top right.",
          },
        ],
      },
    },
    {
      path: "/rules",
      name: "rules",
      component: () =>
        import(/* webpackChunkName: "events" */ "./views/Rules.vue"),
      meta: {
        title: "Unit Rules – Newfound Pioneer Corps Arma 3",
        tags: [
          {
            name: "description",
            content:
              "By playing with the Newfound Pioneer Corps Arma 3 unit you confirm to adhere to our event rules, " +
              "which you can find here.",
          },
        ],
      },
    },
    {
      path: "/server",
      name: "server",
      component: () =>
        import(/* webpackChunkName: "events" */ "./views/Server.vue"),
      meta: {
        title: "Server Information – Newfound Pioneer Corps Arma 3",
        tags: [
          {
            name: "description",
            content:
              "Find information about our Arma 3 server here, including the IP and Port, how many players are " +
              "currently playing and which mod pack it is running.",
          },
        ],
      },
    },
    {
      path: "/tis",
      name: "Tyr Intelligence & Security",
      component: () =>
        import(/* webpackChunkName: "events" */ "./views/Tis.vue"),
      meta: {
        title: "Tyr Intelligence & Security",
        tags: [
          {
            name: "description",
            content:
              "Our currently running Arma 3 PMC Roleplay campaign.",
          },
        ],
      },
    },
    {
      path: "/mod-downloads",
      name: "Mod Downloads",
      component: () =>
        import(/* webpackChunkName: "events" */ "./views/ModDownloadJobs.vue"),
      meta: {
        title: "A list of all mod downloads and their status for review.",
        tags: [
          {
            name: "description",
            content:
              "See the status of all mod downloads.",
          },
        ],
      },
    },
    {
      path: "/mission-analyzer",
      name: "missionAnalyzer",
      component: () =>
        import(/* webpackChunkName: "events" */ "./views/MissionAnalyzer.vue"),
      meta: {
        title: "Mission Analyzer – Newfound Pioneer Corps Arma 3",
        tags: [
          {
            name: "description",
            content:
              "Upload and analyze Arma mission PBO files to extract and debinarize mission content.",
          },
        ],
      },
    },
    {
      path: "/event-promotion",
      name: "Event Promotion",
      component: () =>
        import(/* webpackChunkName: "events" */ "./views/EventPromotion.vue"),
    },
    {
      path: "/badge-management",
      name: "Badge Management",
      component: () =>
        import(/* webpackChunkName: "moderation" */ "./views/IconManagement.vue"),
    },
    {
      path: "/communities",
      name: "Communities",
      component: () =>
        import(/* webpackChunkName: "communities" */ "./views/Communities.vue"),
      meta: {
        title: "Communities – Newfound Pioneer Corps Arma 3",
      },
    },
    {
      path: "/community-management",
      name: "Community Management",
      component: () =>
        import(/* webpackChunkName: "moderation" */ "./views/CommunityManagement.vue"),
      meta: {
        title: "Community Management – Newfound Pioneer Corps Arma 3",
      },
    },
    {
      path: "/profile",
      name: "profile",
      component: () =>
        import(/* webpackChunkName: "profile" */ "./views/Profile.vue"),
      meta: {
        title: "Profile – Newfound Pioneer Corps Arma 3",
      },
    },
    {
      path: "*",
      name: "404",
      component: () => import(/* webpackChunkName: "404" */ "./views/404.vue"),
    },
    {
      path: "/redirect/discord/event",
      name: "redirectDiscordEvent",
      component: () =>
        import(/* webpackChunkName: "404" */ "./views/EventRedirectPage.vue"),
    },
  ],
});

export default router;
